import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {BusinessUnitModel} from '../../models/businessUnit';
import {BusinessUnitService} from '../business-unit.service';
import {takeUntilDestroyed, toSignal} from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class UsineCtxStoreService {
  private readonly usineSubject = new BehaviorSubject<BusinessUnitModel>(null);
  private readonly usineListSubject = new BehaviorSubject<Array<BusinessUnitModel>>([]);
  public readonly $usine = toSignal(this.usine$)

  constructor(
    private readonly usineService: BusinessUnitService,
  ) {
    this.usineService.getListBusinessUnit().pipe(
      takeUntilDestroyed(),
    ).subscribe((usines: Array<BusinessUnitModel>) => {
        this.usineListSubject.next(usines);
      },
    )
  }

  public get usine$(): Observable<BusinessUnitModel> {
    return this.usineSubject.asObservable();
  }

  public setUsine(usine: BusinessUnitModel): void {
    this.usineSubject.next(usine);
  }

  public setUsineById(id: number | string): void {
    const usines = this.usineListSubject.getValue();
    const usine = usines.find(u => u.id == id); //NOSONAR on double equals since types can be mixed (string or number)

    if (usine) {
      this.usineSubject.next(usine);
    } else {
      //Nothing to do, usine not found
    }
  }

  public getUsine(): BusinessUnitModel {
    return this.usineSubject.getValue();
  }
}
